module.exports = __webpack_public_path__ + "img/gb67.prt.dd20b09b.jpg";